import { Component, Injector, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { NavStateService } from '../../nav-shell/nav-state.service';
import { MountedNavComponent, NavShellLoader } from '../../nav-shell/nav-shell.loader';

@Component({

  selector: 'ngx-one-column-layout',
  styleUrls: ['./one-column.layout.scss'],
  template: `
    <nb-layout windowMode [class.nav-redesign]="navEnabled">
      <nb-layout-header fixed style="width: 100vw;">
        <ngx-header></ngx-header>
      </nb-layout-header>

      <nb-sidebar class="menu-sidebar">
        <ng-container #navHost></ng-container>

        <ng-container *ngIf="!navEnabled">
          <ng-content select="nb-menu"></ng-content>

          <div>
            <ng-content>
            </ng-content>
          </div>
          <div style="margin-top: 2.5rem;">
          <ng-content slelct="[menu-footer]">
          </ng-content>
          </div>
        </ng-container>

      </nb-sidebar>

      <nb-layout-column
        style="position: relative; background: #ffffff; padding: 0px;"
      >
        <ng-content select="router-outlet"></ng-content>
        <!-- [page] lets a standalone-routed page (e.g. /client) host itself in this shell
             instead of templating its own nb-layout + duplicate header. -->
        <ng-content select="[page]"></ng-content>
      </nb-layout-column>

<!--      <nb-layout-footer fixed>
        <ngx-footer></ngx-footer>
      </nb-layout-footer> -->
    </nb-layout>
  `,
})
export class OneColumnLayoutComponent implements OnInit, OnDestroy {
  readonly navEnabled = this.nav.enabled;

  @ViewChild('navHost', { read: ViewContainerRef, static: true }) navHost: ViewContainerRef;

  private mounted?: MountedNavComponent;
  private destroyed = false;

  constructor(
    private readonly nav: NavStateService,
    private readonly injector: Injector,
    private readonly loader: NavShellLoader,
  ) {}

  ngOnInit(): void {
    // Global sidebar/drawer rules (_mobile.scss) opt out through body:not(.nav-redesign).
    document.body.classList.toggle('nav-redesign', this.navEnabled);

    if (this.navEnabled) {
      this.loader.mountNavShell(this.navHost, this.injector).then((mounted) => {
        if (this.destroyed) { mounted.destroy(); return; }
        this.mounted = mounted;
      });
    }
  }

  ngOnDestroy(): void {
    this.destroyed = true;
    this.mounted?.destroy();
    document.body.classList.remove('nav-redesign');
  }
}
